<template>
    <div id="agreement">
        <mu-container fluid>
            <h3>{{$t('agreement.title')}}</h3>
            <p>{{$t('agreement.content_line1')}}</p>
            <p>{{$t('agreement.content_line2')}}</p>
            <p>{{$t('agreement.content_line3')}}</p>
            <p>{{$t('agreement.content_line4')}}</p>
        </mu-container>
    </div>
</template>
<script>
export default {
    name: "agreement"
}
</script>
<style scoped>
#agreement h3 {
    font-size:16px;
    color: #000000;
    font-weight: 600;
    text-align: center;
}
#agreement p {
    font-size:14px;
    color: #3d3d3d;
    font-weight: 400;
    margin:16px;
    text-indent: 24px;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/agreement.vue